import {
  getProfileTypeColor,
  getProfileTypeLightColor,
  ProfileTypeName
} from "@platformsh/observability-graph/ContinuousProfiling";
import styled from "styled-components";

export const Layout = styled.div<{
  profileTypeName?: ProfileTypeName;
}>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  --profile-type-color: ${({ profileTypeName }) =>
    profileTypeName ? getProfileTypeColor(profileTypeName) : "none"};
  --profile-type-light-color: ${({ profileTypeName }) =>
    profileTypeName ? getProfileTypeLightColor(profileTypeName) : "none"};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  background-color: var(--section-snow-background-color, var(--snow));
  padding: 24px;
  border-radius: 4px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  flex-wrap: wrap;
  gap: 32px;
`;
